import { matchPath, useLocation } from "react-router-dom";

export const usePathActive = () => {
  const location = useLocation();

  const checkActive = (to: string) => {
    const match = matchPath(
      {
        path: to,
      },
      location.pathname
    );
    return !!match;
  };

  return { checkActive };
};
